<sh-toggle
    [label]="label()"
    [attr.active]="active() ? true : null"
    [disabled]="disabled()"
    [attr.readOnly]="readonly() ? true : null"
></sh-toggle>
